export enum EmbedUrlType {
  VIDEO = 'video',
  GOOGLE_SLIDE = 'google_slide',
  HTML = 'html'
}
